import { HttpInterceptor, HttpRequest, HttpHandler, HttpUserEvent, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { of, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { Globals } from '../../../globals';

export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    public globals: Globals,
  ) { }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      this.authService.logout();
      this.globals.clear();
      if (this.router.url.includes('/scheduler') || this.router.url.includes('/configuration') || this.router.url.includes('/forms/builder') || this.router.url.includes('/studio') || this.router.url.includes('/reports'))
        window.close();
      else if (this.router.url.includes('/patientLogin') || this.router.url.includes('/patientportal'))
        this.router.navigateByUrl(`/patientLogin`);
      else if (this.router.url.includes('/referrerLogin') || this.router.url.includes('/referrerportal'))
        this.router.navigateByUrl(`/referrerLogin`);
      else
        this.router.navigateByUrl(`/`);

      return of(err.message); // or EMPTY may be appropriate here
    }
    return throwError(err);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader);
      return next.handle(req.clone({ headers }));
    }

    if (req.headers.get('Content-Type') === 'application/x-www-form-urlencoded') {
      return next.handle(req.clone());
    }
    else {

      let authToken;
      if (localStorage.getItem('TDOauthToken')) {
        authToken = localStorage.getItem('TDOauthToken');
      } else if (localStorage.getItem('TDOPatientAuthToken')) {
        authToken = localStorage.getItem('TDOPatientAuthToken');
      } else if (localStorage.getItem('TDOReferralPortalAuthToken')) {
        authToken = localStorage.getItem('TDOReferralPortalAuthToken');
      } else {
        authToken = '';
      }
      const clonedreq = req.clone({
        setHeaders: {
          Authorization: 'bearer ' + authToken,
        }
      });
      return next.handle(clonedreq).pipe(catchError(x => this.handleAuthError(x)));
    }
  }

  istokenexpired(): boolean {
    if (localStorage.getItem('TDOauthToken') != null) {
      if (this.getExpiration() > moment.now()) {
        return false;
      }
      else {
        localStorage.removeItem('TDOauthToken');
      }
    }
    return true;
  }

  getExpiration(): any {
    const expiration = localStorage.getItem('expires_at');
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }
}
